export class OrganizationRoles {
  public static ORGANIZATION_ADMIN = 'Admin'
  public static ORGANIZATION_DISPATCHER = 'Dispatcher'
}



// WEBPACK FOOTER //
// ./src/constants/organization-team-member-roles.ts